import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('marketingSmsManagementDetailsStore')
@observer
class SearchResult extends Component {
  state = {
  }

  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsManagementDetailsStore} = this.props
    marketingSmsManagementDetailsStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsManagementDetailsStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList} = marketingSmsManagementDetailsStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} >
          <Table.Column title={t(`marketingManagement.phone`)} dataIndex="phone" key="phone" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.receiptTime`)} dataIndex="respTime" key="respTime" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.receiptStatus`)} dataIndex="status" key="status" ellipsis={true} render={
            (text, record) => {
              return <span style={record.respCode !== 'DELIVRD' ? {color: 'red'} : null}>{text}</span>
            }
          } />
          <Table.Column title={t(`marketingManagement.statusCode`)} dataIndex="respCode" key="respCode" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.smsContent`)} dataIndex="content" key="content" ellipsis={true} />
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
